import { motion } from "framer-motion";
import AboutCard from "../component/AboutCard";

const About = () => {
  return (
    <section className="w-full min-h-screen px-4 sm:px-6 lg:px-16 xl:px-20 py-16">
      {/* Heading area */}
      <div className="max-w-7xl mx-auto mb-12">
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false }}
          className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl 
                 bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] 
                 bg-clip-text text-transparent 
                 font-aileron font-bold"
        >
          Why Azero Tech
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: false }}
          className="text-gray-600 text-base sm:text-lg lg:text-xl 
                 max-w-3xl font-normal font-clash mt-4"
        >
          Our commitment to quality, creativity, and innovation sets Azero Tech
          apart. We build digital experiences that help your business grow.
        </motion.p>
      </div>

      {/* Content area */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false }}
          className="w-full"
        >
          <div className="flex justify-center items-center w-full py-6 sm:py-10">
            <div
              className="relative 
      w-[240px] sm:w-[320px] md:w-[380px] lg:w-[420px] 
      aspect-square"
            >
              {/* CLOCKWISE → Rings */}
              <div className="absolute inset-0 animate-spin-cw">
                <div className="absolute inset-0 rounded-full border border-gray-300"></div>
                <div className="absolute inset-[12%] rounded-full border border-gray-300"></div>
                <div className="absolute inset-[24%] rounded-full border border-gray-300"></div>
              </div>

              <div className="absolute inset-0 ">
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <AboutCard color="bg-red-500" text="Energy and Innovation" />
                </div>
                {/* Right */}
                <div className="absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-1/2">
                  <AboutCard
                    color="bg-white border"
                    text="Clarity and Balance"
                  />
                </div>

                <div className="absolute bottom-0 left-0 transform translate-x-1/2 translate-y-1/2">
                  <AboutCard
                    color="bg-black"
                    text="Strength and Professionalism"
                  />
                </div>
              </div>

              <div className="absolute inset-1/3 rounded-full overflow-hiddee z-10">
                <img
                  src="/assets/about-azero.png"
                  alt="Azero"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false }}
          className="w-full"
        >
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl 
                   font-bold mb-6 
                   bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] 
                   bg-clip-text text-transparent font-aileron"
          >
            About Azero Tech
          </h2>

          <p
            className="text-gray-600 text-base sm:text-lg lg:text-xl 
                    leading-relaxed mb-8 font-normal font-clash max-w-2xl"
          >
            At Azero Tech, we combine innovation with a personalized approach to
            deliver custom solutions that set you apart. Our team’s dedication
            to quality ensures your brand stands strong in a competitive market.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[
              { title: "Creative Design", desc: "Modern, user-focused UI/UX" },
              {
                title: "Smart Solutions",
                desc: "Tailored for business growth",
              },
              { title: "Reliable Support", desc: "We’re always with you" },
              { title: "Quality Code", desc: "Clean, scalable development" },
            ].map((item, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.03 }}
                className="bg-white p-5 sm:p-6 rounded-2xl 
                       border border-[#FFD6D2] shadow-sm 
                       hover:shadow-lg transition"
              >
                <h3 className="text-lg sm:text-xl font-semibold text-[#FE4A33] font-aileron">
                  {item.title}
                </h3>
                <p className="text-gray-600 mt-2 font-normal font-clash text-sm sm:text-base">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
